import { Directive, Input, TemplateRef, ViewContainerRef, ComponentRef } from '@angular/core';
import { AppSkeletonLoaderUiComponent } from '../components/app-skeleton-loader-ui/app-skeleton-loader-ui.component';



@Directive({
  selector: '[appSkeleton]',
  standalone: true
})
export class SkeletonDirective {
  private currentState: 'SKELETON' | 'CONTENT' | 'NONE' = 'NONE';
  private isLoading = false;
  private _theme: any;
  private skeletonRef: ComponentRef<AppSkeletonLoaderUiComponent> | null = null;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) { }

  @Input() set appSkeleton(condition: boolean) {
    this.isLoading = condition;
    this.updateView();
  }

  @Input() set appSkeletonTheme(theme: any) {
    this._theme = theme;
    if (this.skeletonRef) {
      this.skeletonRef.instance.theme = theme;
      this.skeletonRef.changeDetectorRef.detectChanges();
    }
  }

  private updateView() {
    if (this.isLoading) {
      if (this.currentState !== 'SKELETON') {
        this.viewContainer.clear();
        this.skeletonRef = this.viewContainer.createComponent(AppSkeletonLoaderUiComponent);
        if (this._theme) {
          this.skeletonRef.instance.theme = this._theme;
        }
        this.currentState = 'SKELETON';
      }
    } else {
      if (this.currentState !== 'CONTENT') {
        this.viewContainer.clear();
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.currentState = 'CONTENT';
        this.skeletonRef = null;
      }
    }
  }
}
